export type NormalizedError = {
  title: string;
  message: string;
};

export function parseApiError(source: unknown, fallbackTitle = "Error"): NormalizedError {
  if (!source || typeof source !== "object") {
    return { title: fallbackTitle, message: typeof source === "string" ? source : "Unexpected error" };
  }
  const err = source as { message?: string; payload?: any; detail?: unknown };
  const detail = err.payload?.detail ?? err.detail;
  if (detail && typeof detail === "object") {
    const title = typeof detail.title === "string" ? detail.title : fallbackTitle;
    const message =
      typeof detail.message === "string"
        ? detail.message
        : typeof (detail as any).detail === "string"
          ? (detail as any).detail
          : JSON.stringify(detail);
    return { title, message };
  }
  if (typeof detail === "string") {
    return { title: fallbackTitle, message: detail };
  }
  return {
    title: fallbackTitle,
    message: err.message || "Unexpected error",
  };
}
